import { Accordion } from '@r-and-a-shared-ui/common-ui';
import { kontentAiDataMapping } from '@r-and-a-shared-ui/core-data-mapping';

import {
  MEMBERSHIP_MODELS,
  PLAYER_PORTALS_MODELS,
} from '@r-and-a-shared-ui/common-kontent-client';
export default {
  component: () => Accordion,
  mapEntryToProps: (
    entry: MEMBERSHIP_MODELS.Accordion & PLAYER_PORTALS_MODELS.Accordion,
  ) => kontentAiDataMapping.accordion(entry),
};
